import React, { Component } from 'react';
import { connect } from 'react-redux';
import RemoteImageSplashListWrap from '../../../views/remoteImage/splash/list/RemoteImageSplashListWrap';
import { remoteImageActions } from '../../../store/modules/remoteImage';

class RemoteImageSplashListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = () => {
    this.getList();
  };

  /**
   *  리스트 가져오기
   */
  getList = (data) => {
    const { pageType, getRemoteImageSplashList, remoteImageSplashList } = this.props;
    const { searchOption, pagination } = remoteImageSplashList;

    getRemoteImageSplashList({
      pageType,
      searchOption,
      pagination,
      ...data,
    });
  };

  render() {
    const { remoteImageSplashList, setData } = this.props;

    return (
      <RemoteImageSplashListWrap
        remoteImageSplashList={remoteImageSplashList}
        setData={setData}
        getList={this.getList}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    remoteImageSplashList: state.remoteImage.remoteImageSplashList,
  };
};

const mapDispatchToProps = {
  setData: remoteImageActions.setData,
  getRemoteImageSplashList: remoteImageActions.getRemoteImageSplashList,
};

export default connect(mapStateToProps, mapDispatchToProps)(RemoteImageSplashListContainer);
